import React, { FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeApiCall } from "src/api/apiRequests";
import API_PATHS from "src/api/apiPaths";
import SearchFilter from "src/helpers/SearchFilter";
import API_HEADERS from "src/api/apiConfig";
import CustomPagination from "src/helpers/CustomPaginate";
import ListResponse from "src/helpers/ListResponse";
import Loading from "src/helpers/Loading";
import ViewPerformance from "./ViewPerformance";
import EvaluationStars from "./EvaluationStars";
import moment from "moment";
import { PermissionCheck } from "src/helpers/PermissionCheck";
import Select, { SingleValue } from "react-select";
import ResponsiblePersons from "../children/show/tabs/Resposible_persons/ResponsiblePersons";

const TeacherPerformance: React.FC = () => {
  const { t } = useTranslation();

  const [authorId, setAuthorId] =
    useState<SingleValue<{ value: number; label: string }>>();
  const [authors, setAuthors] = useState<any>([]);
  const [performanceList, setPerformanceList] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [searchBtnLoading, setSearchBtnLoading] = useState(false);
  const [activePage, setActivePage] = useState<number>(1);

  // Modals
  const [showViewModal, setShowViewModal] = useState<boolean>(false);
  const [modalId, setModalId] = useState<number | null>(null);

  const fetchEvaluations = async (
    e?: FormEvent<HTMLFormElement>
  ): Promise<void> => {
    e?.preventDefault();
    setSearchBtnLoading(true);
    setLoading(true);

    const searchParams: any = {
      pagination: 10,
      author_id: authorId ? authorId.value : "",
    };

    if (activePage > 1) {
      searchParams["page"] = activePage;
    }

    const request: any = SearchFilter(
      searchParams,
      API_PATHS.teachersEvaluationList
    );

    try {
      const response: any = await makeApiCall<ResponseType>(
        request,
        "GET",
        API_HEADERS.authenticated
      );
     
      setAuthors(response.authors);
      setPerformanceList(response.teachersevaluation);
      setLoading(false);
      setSearchBtnLoading(false);
    } catch (error: any) {
      setSearchBtnLoading(false);
    }
  };
  useEffect(() => {
    fetchEvaluations();
  }, []);

 

  return (
    <>
      <div className="customized-tabs">
        <div className="row mb-5">
          <div className="form-block col-12 col-sm-6 col-md-3 col-xxl-2">
            <label>{t("performance_search_author_label")}</label>
            <Select
              placeholder={t("performance_search_author_placeholder")}
              className="form-react-select"
              classNamePrefix="select_input"
              onChange={(e: any) => {
                setAuthorId(e);
              }}
              isClearable={true}
              isSearchable={false}
              options={authors.map((item: any) => ({
                value: item.id,
                label: `${item.first_name} ${item.last_name}`,
              }))}
              value={authorId}
            />
          </div>
          <div className="col-12 col-sm-6 col-md-3 mb-1 mt-4">
            {searchBtnLoading ? (
              <button type="button" className="button-orange has-icon">
                <i className="icon spinner-icon" />
                {t("teachers_searching")}
              </button>
            ) : (
              <button
                type="submit"
                className="button-orange has-icon"
                onClick={(e: any) => {
                  e.preventDefault();
                  fetchEvaluations(e);
                }}
              >
                <i className="icon search-icon" />
                {t("teachers_search")}
              </button>
            )}
          </div>
        </div>

        <div className="tab-content">
          <div className="table-list mb-5">
            <table role="table" className="w-100">
              <thead>
                <tr role="row">
                  <th
                    style={{ width: "23%" }}
                    role="columnheader"
                    className="text-left"
                  >
                    <i className="icon teacher-icon" />
                    {t("teacher_performance_author_name")}
                  </th>
                  <th
                    style={{ width: "25%" }}
                    role="columnheader"
                    className="text-left"
                  >
                    <i className="icon calender-icon" />
                    {t("teacher_performance_evaluation_date")}
                  </th>
                  <th
                    style={{ width: "18%" }}
                    role="columnheader"
                    className="text-left"
                  >
                    <i className="icon comment-icon" />
                    {t("teacher_performance_comment")}
                  </th>
                  <th
                    style={{ width: "15%" }}
                    role="columnheader"
                    className="text-left"
                  >
                    <i className="icon evaluation-icon" />
                    {t("teacher_performance_score")}
                  </th>
                  <th
                    style={{ width: "17%" }}
                    role="columnheader"
                    className="text-center"
                  >
                    <i className="icon actions-icon" />
                    {t("teacher_performance_action")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td className="text-center" colSpan={5}>
                      <Loading />
                    </td>
                  </tr>
                ) : (
                  performanceList?.data?.map((performance: any) => (
                    <tr key={performance.id}>
                      <td
                        role="cell"
                        className="text-left bold-text"
                        data-label={t("teacher_performance_author_name")}
                      >
                        {`${performance.author.first_name} ${performance.author.last_name}`}
                      </td>
                      <td
                        role="cell"
                        className="text-left"
                        data-label={t("teacher_performance_evaluation_date")}
                      >
                        {moment(performance.evaluation_date).format(
                          "DD-MM-YYYY"
                        )}
                      </td>
                      <td
                        role="cell"
                        className="text-left"
                        data-label={t("teacher_performance_comment")}
                      >
                        {performance.evaluation_comment
                          ? performance.evaluation_comment.length > 100
                            ? performance.evaluation_comment.substring(0, 100) +
                              "..."
                            : performance.evaluation_comment
                          : "-"}
                      </td>
                      <td
                        role="cell"
                        className="text-left"
                        data-label={t("teacher_performance_score")}
                      >
                        <EvaluationStars
                          evaluationNr={performance.evaluation_score}
                        />
                      </td>
                      <td
                        role="cell"
                        className="text-center"
                        data-label={t("teacher_performance_action")}
                      >
                        <div className="actions">
                          {PermissionCheck("performance-my-edit") ? (
                            <button
                              className="button-unstyled-icon"
                              onClick={() => {
                                setShowViewModal(true);
                                setModalId(performance.id);
                              }}
                            >
                              <i className="icon show-icon" />
                            </button>
                          ) : (
                            "-"
                          )}

                          {showViewModal && modalId === performance.id && (
                            <ViewPerformance
                              onShowModal={showViewModal}
                              setShowModal={(e) => {
                                setShowViewModal(e);
                                setModalId(null);
                              }}
                              performanceId={performance.id}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <ListResponse
              totalItems={performanceList?.data?.length}
              loading={loading}
            />
          </div>
          <CustomPagination
            data={performanceList}
            setActivePage={(e) => setActivePage(e)}
          />
        </div>
      </div>
    </>
  );
};

export default TeacherPerformance;
